import styled from '@emotion/styled';

import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

import PlantATreeImg from 'assets/images/plant-a-tree.jpg';

export const PlantATreeAdTile = styled.a`
  background: url(${PlantATreeImg}) center;
  background-size: contain;
  border-radius: 8px;
  cursor: pointer;
  height: 100%;
`;

export const PlantATreeCopyWrapper = styled.div<{ addMarginTop?: boolean }>`
  color: ${COLORS3.FOREST_100};
  display: flex;
  margin-top: ${({ addMarginTop }) => (addMarginTop ? SPACING.S16 : 0)};

  a,
  p {
    color: ${COLORS3.FOREST_100};
  }

  svg {
    flex-shrink: 0;
  }
`;
